import { EquipmentState } from '@frontend/equipment/types';
import { Application } from '@frontend/functionality/types';
import { OrderStatus } from '@frontend/order/types';
import { ProductClient } from '@frontend/product/api';
import { TransactionState } from '@frontend/transaction/types';

import { FilterCheckboxCardProps } from './filter-checkbox-card.component';

export const useFilterCheckboxCard = (props: FilterCheckboxCardProps) => {
    const getEntities = async (type: string) => {
        switch (type) {
            case 'product_id': {
                const products = await ProductClient.fetchProducts();
                return products.results.map((item) => ({
                    value: item.id,
                    label: item.name
                }));
            }
            case 'equipment_state': {
                const states = EquipmentState.ALL;
                return states.map((item) => ({ value: item.value, label: item.displayName }));
            }
            case 'application': {
                const applications = Object.values(Application);
                return applications.map((item) => ({ value: item, label: item.replace(/_/g, ' ') }));
            }
            case 'state': {
                const allStates = [
                    TransactionState.TRANSACTION_CREATED,
                    TransactionState.TRANSACTION_DROP_OFF_PENDING,
                    TransactionState.TRANSACTION_PICK_UP_PENDING,
                    TransactionState.TRANSACTION_COMPLETED,
                    TransactionState.TRANSACTION_CANCELLED
                ];

                const statesToUse = props.subset ? allStates.filter((state) => props.subset?.includes(state.value)) : allStates;
                return statesToUse.map((item) => ({ value: item.value, label: item.displayName }));
            }
            case 'status': {
                const allStatuses = OrderStatus.ALL;
                const statusesToUse = props.subset ? allStatuses.filter((status) => props.subset?.includes(status.name)) : allStatuses;
                return statusesToUse.map((item) => ({ value: item.name, label: item.display }));
            }
            default:
                return [];
        }
    };

    return {
        getEntities
    };
};
